import { Typography, TypographyProps, styled } from "@mui/material";

const NormalRedTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
    color: "#ff1744",
    fontSize: '12px',
    fontWeight: 600
}));

export default NormalRedTypography